import { BOOKADD, BOOKLEADED, DELETEBOOK, EDIT } from "./actionTypes";

export const bookLoaded = (books) => {
 return {
  type: BOOKLEADED,
  payload: books,
 };
};
export const addBook = (bookDetails) => {
 return {
  type: BOOKADD,
  payload: bookDetails,
 };
};
export const deleteBook = (id) => {
 return {
  type: DELETEBOOK,
  payload: id,
 };
};

export const edit = (book) => {
 return {
  type: EDIT,
  payload: book,
 };
};
